module.exports = __webpack_public_path__ + "static/media/icon-event-date.6f534c8a.svg";